var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69572 5.79621C5.96274 6.67821 7.70574 6.37023 8.58774 5.11023C9.47676 3.84321 9.16871 2.10021 7.90176 1.21125C6.63474 0.322232 4.89174 0.63021 4.00272 1.89723C3.12072 3.16419 3.42876 4.90718 4.69572 5.79621Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55102 20.9471L2.80002 7.70312H0L2.793 21.3601C3.31098 24.7761 6.25097 27.3031 9.70901 27.3031H19.6V24.5031H9.70199C7.63002 24.503 5.86602 22.991 5.55102 20.9471Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9223 18.9017H13.0904L11.6554 13.1617C13.8604 14.4077 16.2474 15.3247 18.8654 14.8697V11.8948C16.5834 12.3218 14.0494 11.5097 12.2994 10.1518L9.99644 8.35974C9.68144 8.11476 9.31047 7.93974 8.92545 7.82772C8.48445 7.70172 8.00847 7.66674 7.53945 7.74372L7.50447 7.75074C5.78949 8.05176 4.64145 9.68274 4.94247 11.3977L6.83949 19.6857C7.21749 21.6667 8.94651 23.1017 10.9625 23.1017H20.5525L25.9005 27.3017L28.0005 25.2017L19.9223 18.9017Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/seat-icon.4d5c4d1dc4376ddacd1a487f6533cbe8.svg";
export { ForwardRef as ReactComponent };